export default {
    getCurrentLocation: function() {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition((data) => {
                var lat = data.coords.latitude;
                var lng = data.coords.longitude;
                resolve({lat: lat, lng: lng});
            }, (error) => {
                reject(error);
            });
        });
    },
    getAddressType: function(address, type) {
        var ans = null;
        if (address.length > 0) {
            address[0].address_components.some(function (tmp) {
                ans = '';
                tmp.types.forEach(function (t) {
                    if (t == type) {
                        ans = tmp.long_name;
                    }
                });
                if (ans != null) {
                    return ans;
                }
            });
        }
        
        return ans;
    },
    getDistrict: function(address) {
        var district = this.getAddressType(address, 'sublocality_level_1'); // กรุงเทพ
        if (district == '') {
            district = this.getAddressType(address, 'administrative_area_level_2'); // ต่างจังหวัด
        }
        return district;
    },
    getSubDistrict: function(address) {
        var subDistrict = this.getAddressType(address, 'sublocality_level_2'); // กรุงเทพ
        if (subDistrict == '') {
            subDistrict = this.getAddressType(address, 'locality'); // ต่างจังหวัด
        }
        return subDistrict;
    }
}